import resolveObject from "./object-mjs";

function getTypeFromInlineFragment(info) {
  var selection = info.fieldNodes[0].selectionSet.selections.find(function (_ref) {
    var kind = _ref.kind;
    return kind === "InlineFragment";
  });

  if (selection) {
    var typeName = selection.typeCondition.name.value;
    return info.schema.getTypeMap()[typeName];
  }
}

function resolveFromImplementations(obj, args, context, info, type) {
  var _info$schema$getImple = info.schema.getImplementations(type),
      implementations = _info$schema$getImple.objects;

  return implementations.map(function (implType) {
    return resolveObject(obj, args, context, info, implType);
  }).find(function (record) {
    return record != null;
  });
}

export default function resolveInterface(obj, args, context, info, type) {
  var implType = getTypeFromInlineFragment(info);
  return implType ? resolveObject(obj, args, context, info, implType) : resolveFromImplementations(obj, args, context, info, type);
}
